





import Vue, {PropType} from 'vue'

export default Vue.extend({
name: "BaseLogo",
  props: {
    locale: {
      type: String as PropType<'en'|'fi'|'se'>,
      required: true
    }
  },
  computed: {
    logoComp(){
      return {
        'en': ()=>import('./BaseLogoEn.vue'),
        'fi': ()=>import('./BaseLogoFi.vue'),
        'se': ()=>import('./BaseLogoSe.vue'),
      }[this.locale as any]
    }
  }
})
